<script>
  import SubHeader from 'src/pc/components/SubHeader'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: SubHeader,
    components: {
      DisplayContainer
    }
  }
</script>

<style>
  .ad_wrap.head {
    min-width: 100vw !important;
    padding: 0 !important;
    text-align: center;
    top: 0 !important;
  }
  .ad_wrap.head a {
    padding: 15px 0;
  }
  .ad_wrap.head.home a {
    margin-bottom: -15px !important;
  }
  .ad_wrap.head.home .inner a img {
    width: 300px !important;
    height: auto !important;
  }
  .ad_wrap.head .inner a img {
    width: 300px !important;
    height: auto !important;
  }
</style>
